"use strict";

/* ==========================================================
   HELPERS
========================================================== */

const $ = (selector, scope = document) => scope.querySelector(selector);

const $$ = (selector, scope = document) =>
    [...scope.querySelectorAll(selector)];

/* ==========================================================
   GALLERY
========================================================== */

function initGallery() {

    const gallery = $(".air-hero__gallery");

    if (!gallery) return;

    const slides = $$(".air-gallery-slide", gallery);

    const thumbs = $$(".air-thumb", gallery);

    if (!slides.length || !thumbs.length) return;

    function activate(mediaId) {

        slides.forEach(slide => {

            slide.classList.toggle(
                "is-active",
                slide.dataset.mediaId === mediaId
            );

        });

        thumbs.forEach(thumb => {

            thumb.classList.toggle(
                "is-active",
                thumb.dataset.mediaId === mediaId
            );

        });

    }

    thumbs.forEach(button => {

        button.addEventListener("click", () => {

            activate(button.dataset.mediaId);

        });

    });

}

/* ==========================================================
   PLACEHOLDER
========================================================== */

function initVariantPicker() {}

function initStickyCart() {}

function initAjaxCart() {}

function initFaq() {}

function initReveal() {}

/* ==========================================================
   INIT
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    initGallery();

    initVariantPicker();

    initStickyCart();

    initAjaxCart();

    initFaq();

    initReveal();

});

/* ==========================================================
   VARIANT PICKER
========================================================== */

function initVariantPicker() {

    const picker = $(".air-variant-picker");

    if (!picker) return;

    const json = $("#AirVariants");

    if (!json) return;

    const variants = JSON.parse(json.textContent);

    const hiddenInput = $("input[name='id']");

    const priceCurrent = $(".air-price-current");

    const priceCompare = $(".air-price-old");

    const stock = $(".air-stock");

    const optionGroups = $$(".air-option-group");

    let selected = [];

    optionGroups.forEach(group => {

        const active = $(".air-option-value.is-active", group);

        if (active) {

            selected.push(active.dataset.optionValue);

        }

    });

    function formatMoney(cents) {

        return new Intl.NumberFormat("de-DE", {

            style: "currency",

            currency: "EUR"

        }).format(cents / 100);

    }

    function findVariant() {

        return variants.find(v =>

            v.options.every((option, index) =>

                option === selected[index]

            )

        );

    }

    function updateGallery(variant) {

        if (!variant.featured_media) return;

        const id = String(variant.featured_media.id);

        $(".air-thumb[data-media-id='" + id + "']")?.click();

    }

    function updateInventory(variant) {

        if (!stock) return;

        if (variant.available) {

            stock.innerHTML = `

                <span class="air-stock-dot"></span>

                <span>Sofort verfügbar</span>

            `;

        } else {

            stock.innerHTML = `

                <span class="air-stock-dot air-stock-dot--red"></span>

                <span>Nicht verfügbar</span>

            `;

        }

    }

    function updatePrice(variant) {

        if (priceCurrent) {

            priceCurrent.textContent = formatMoney(variant.price);

        }

        if (priceCompare) {

            if (

                variant.compare_at_price &&
                variant.compare_at_price > variant.price

            ) {

                priceCompare.style.display = "";

                priceCompare.textContent = formatMoney(

                    variant.compare_at_price

                );

            } else {

                priceCompare.style.display = "none";

            }

        }

    }

    function updateVariant() {

        const variant = findVariant();

        if (!variant) return;

        if (hiddenInput) {

            hiddenInput.value = variant.id;

        }

        updatePrice(variant);

        updateInventory(variant);

        updateGallery(variant);

        window.history.replaceState(

            {},

            "",

            "?variant=" + variant.id

        );

    }

    optionGroups.forEach((group, groupIndex) => {

        const buttons = $$(".air-option-value", group);

        buttons.forEach(button => {

            button.addEventListener("click", () => {

                buttons.forEach(item => {

                    item.classList.remove("is-active");

                });

                button.classList.add("is-active");

                selected[groupIndex] = button.dataset.optionValue;

                updateVariant();

            });

        });

    });

    updateVariant();

}

/* ==========================================================
   AJAX CART
========================================================== */

function initAjaxCart() {

    const form = $(".air-product-form");

    if (!form) return;

    const button = $("button[type='submit']", form);

    if (!button) return;

    const originalText = button.innerHTML;

    form.addEventListener("submit", async event => {

        event.preventDefault();

        button.disabled = true;

        button.classList.add("is-loading");

        button.innerHTML = "Wird hinzugefügt...";

        try {

            const response = await fetch("/cart/add.js", {

                method: "POST",

                headers: {

                    "Content-Type": "application/x-www-form-urlencoded"

                },

                body: new URLSearchParams(new FormData(form))

            });

            if (!response.ok) {

                throw new Error("Cart Error");

            }

            document.dispatchEvent(

                new CustomEvent("air:cart:added")

            );

            await refreshCart();

        }

        catch (error) {

            console.error(error);

            alert("Das Produkt konnte nicht zum Warenkorb hinzugefügt werden.");

        }

        finally {

            button.disabled = false;

            button.classList.remove("is-loading");

            button.innerHTML = originalText;

        }

    });

}

/* ==========================================================
   CART REFRESH
========================================================== */

async function refreshCart() {

    try {

        const response = await fetch("/cart.js");

        const cart = await response.json();

        updateStickyCart(cart);

        document.dispatchEvent(

            new CustomEvent("cart:refresh", {

                detail: cart

            })

        );

    }

    catch(error){

        console.error(error);

    }

}

/* ==========================================================
   STICKY CART
========================================================== */

function initStickyCart() {

    const sticky = $("#AirStickyCart");

    const hero = $(".air-hero");

    if (!sticky || !hero) return;

    const counter = $(".air-sticky-count", sticky);

    const total = $(".air-sticky-total", sticky);

    const observer = new IntersectionObserver(

        ([entry]) => {

            sticky.classList.toggle(

                "is-visible",

                !entry.isIntersecting

            );

        },

        {

            threshold:0.15

        }

    );

    observer.observe(hero);

    document.addEventListener(

        "cart:refresh",

        event => {

            updateStickyCart(event.detail);

        }

    );

}

/* ==========================================================
   UPDATE STICKY CART
========================================================== */

function updateStickyCart(cart){

    const sticky=$("#AirStickyCart");

    if(!sticky) return;

    const count=$(".air-sticky-count",sticky);

    const total=$(".air-sticky-total",sticky);

    if(count){

        count.textContent=cart.item_count;

    }

    if(total){

        total.textContent=new Intl.NumberFormat(

            "de-DE",

            {

                style:"currency",

                currency:"EUR"

            }

        ).format(cart.total_price/100);

    }

}

/* ==========================================================
   FAQ
========================================================== */

function initFaq() {

    const items = $$(".air-faq-item");

    if (!items.length) return;

    items.forEach(item => {

        const summary = $("summary", item);

        if (!summary) return;

        summary.setAttribute("role", "button");

        summary.setAttribute(
            "aria-expanded",
            item.open
        );

        item.addEventListener("toggle", () => {

            summary.setAttribute(
                "aria-expanded",
                item.open
            );

        });

    });

}

/* ==========================================================
   REVEAL ANIMATION
========================================================== */

function initReveal() {

    const elements = $$("[data-reveal]");

    if (!elements.length) return;

    const observer = new IntersectionObserver(

        entries => {

            entries.forEach(entry => {

                if (!entry.isIntersecting) return;

                entry.target.classList.add("is-visible");

                observer.unobserve(entry.target);

            });

        },

        {

            threshold:0.15,

            rootMargin:"0px 0px -50px 0px"

        }

    );

    elements.forEach(element => {

        observer.observe(element);

    });

}

/* ==========================================================
   ACCESSIBILITY
========================================================== */

document.addEventListener(

    "keydown",

    event => {

        if(event.key!=="Escape") return;

        document

            .querySelectorAll("dialog[open]")

            .forEach(dialog=>dialog.close());

    }

);

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.15
});

document.querySelectorAll('.air-benefit-card, .air-step').forEach((el) => {
  observer.observe(el);
});
